export const branchPublicUrl = (branch, origin = window.location.origin) => {
  const fragment = branch.public_slug || branch.uuid || branch.id;
  return fragment ? `${origin.replace(/\/$/, '')}/branch/#${encodeURIComponent(fragment)}` : '';
};
